import { parse } from 'psl';

const FALLBACK_DOMAIN = 'zd87.com';

// 使用公共后缀规则提取主域名，兼容 example.com.cn 等多段后缀。
// 本地地址、IP、未知后缀或缺少浏览器环境时，使用兜底域名。
export const getFleetDomain = (hostname = typeof window === 'undefined' ? '' : window.location.hostname) => {
  if (typeof hostname !== 'string') return FALLBACK_DOMAIN;
  const normalizedHostname = hostname.trim().toLowerCase().replace(/\.$/, '');
  if (!normalizedHostname || normalizedHostname.includes(':') || /^[\d.]+$/.test(normalizedHostname)) {
    return FALLBACK_DOMAIN;
  }
  const parsed = parse(normalizedHostname);
  return parsed.listed && parsed.domain ? parsed.domain : FALLBACK_DOMAIN;
};

const getFleetBaseUrl = (subdomain) => `https://${subdomain}.${getFleetDomain()}`;

// AI车队配置文件
// Claude、Gemini、Grok 默认使用美国线路。
export const AI_FLEET_CONFIG = {
  grok: {
    get baseUrl() { return getFleetBaseUrl('grok'); },
    authBridgePath: '/grok-auth-bridge.html',
    authApiPath: '/auth/loginToken'
  },

  claude: {
    get baseUrl() { return getFleetBaseUrl('c'); },
    authBridgePath: '/claude-auth-bridge.html',
    authApiPath: '/auth/loginToken'
  },

  gemini: {
    get baseUrl() { return getFleetBaseUrl('gemini'); },
    authBridgePath: '/gemini-auth-bridge.html',
    authApiPath: '/auth/loginToken'
  },

  sora: {
    baseUrl: 'https://sora.aimonkey.plus',
    authBridgePath: '/sora-auth-bridge.html',
    authApiPath: '/auth/loginToken'
  },

  'claude-v2': {
    baseUrl: 'https://c.aimonkey.vip',
    authBridgePath: '/claude-v2-auth-bridge.html',
    authApiPath: '/login'
  },

  'gpt-backup': {
    get baseUrl() { return getFleetBaseUrl('ai001'); },
    authBridgePath: '/gpt-backup-auth-bridge.html',
    authApiPath: '/auth/login'  // 注意：GPT Plus车队使用不同的API路径
  },

  'gpt-plus': {
    baseUrl: 'https://g.zd87.com',
    authBridgePath: '/gpt-backup-auth-bridge.html',
    authApiPath: '/auth/login'
  }
};

// 获取完整的鉴权桥接URL
export const getAuthBridgeUrl = (fleetType) => {
  const config = AI_FLEET_CONFIG[fleetType];
  if (!config) {
    throw new Error(`未找到 ${fleetType} 的配置`);
  }
  return `${config.baseUrl}${config.authBridgePath}`;
};

// 获取鉴权API URL
export const getAuthApiUrl = (fleetType) => {
  const config = AI_FLEET_CONFIG[fleetType];
  if (!config) {
    throw new Error(`未找到 ${fleetType} 的配置`);
  }
  return `${config.baseUrl}${config.authApiPath}`;
};
